import React, { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import AdminBreadcrumb from './AdminBreadcrumb';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleCloseSidebar = useCallback(() => setIsSidebarOpen(false), []);
  const handleToggleSidebar = useCallback(() => setIsSidebarOpen((prev) => !prev), []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header onToggleSidebar={handleToggleSidebar} isAdminPage={isAdminPage} />
      {isAdminPage ? (
        <div className="flex flex-1 min-h-screen">
          <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} />
          <div className="flex-1 flex flex-col min-h-0">
            <main className="flex-1 overflow-auto lg:ml-64 px-4 lg:pl-6">
              <AdminBreadcrumb />
              {children}
            </main>
            <div className="lg:ml-64">
              <Footer />
            </div>
          </div>
        </div>
      ) : (
        <>
          <main className="flex-grow">
            {children}
          </main>
          <Footer />
        </>
      )}
    </div>
  );
};

export default Layout;